import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';

import Button from 'components/DesignSystem/Button';
import { useMyStudiesProduct } from 'components/Flux/Personalized/MyStudies/product';

/**
 * Estado 4 da lista da aba Meus Estudos, "empresa sem nenhum estudo" (#2003, .dc.html:268-274 e
 * 431-441): a lista veio vazia e o escopo do usuário não tem nenhum estudo (`escopo_tem_estudos`
 * falso). Não há o que filtrar: a casca esconde a barra de filtros e a contagem, e o cartão chama
 * direto para a outra aba.
 *
 * - Texto auxiliar da D26-1: o do protótipo interativo (.dc.html:271), e não o resumido do
 *   cartão do estado 4 (.dc.html:437).
 * - Título, texto, CTA e caminho vêm de `emptyCompany` do produto (`useMyStudiesProduct()`): o
 *   Personalizado e o Upload definem os seus. O CTA fica em caixa-alta pelo CSS (o leitor de tela
 *   não soletra) e leva ao `newStudyPath` do produto com push: a aba Novo fica ativa pela rota, e
 *   voltar retorna à lista.
 * - O título é um heading (h2): o estado 4 aparece na carga da tela, quando o conteúdo é lido, e
 *   não anunciado. A contagem some junto com a barra.
 */
export default function EmptyCompanyState() {
  const navigate = useNavigate();
  const { emptyCompany } = useMyStudiesProduct();
  const goToNewStudy = useCallback(
    () => navigate(emptyCompany.newStudyPath),
    [navigate, emptyCompany.newStudyPath],
  );

  return (
    <div className="my-studies-empty my-studies-empty-company" data-testid="my-studies-empty-company">
      <h2 className="my-studies-empty-title">{emptyCompany.title}</h2>
      <p className="my-studies-empty-text">{emptyCompany.text}</p>
      <Button small className="my-studies-empty-cta" onClick={goToNewStudy}>
        {emptyCompany.cta}
      </Button>
    </div>
  );
}
